import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { beforeSetupsr6thgzteo9n as beforeSetup } from '../views/ElementWriter.ext.mjs';
import { shownWhen3t7othivfr11 as shownWhen } from '../views/direct/modifiers.commonHtml.mjs';
import {
  ErrorSemantic_getInstance1asme2of31cag as ErrorSemantic_getInstance,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
  None_instance1vdtnxdfytk8h as None_instance,
  InvalidSemantic_getInstance2x7tbxxpbj713 as InvalidSemantic_getInstance,
} from '../models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../views/themeDerivations.mjs';
import {
  TextViewe6rp77b08kos as TextView,
  TextView$_get_content_$ref_4pzcwl16uunx6j4t5r9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb3nnz1ag2pn6vb as TextView$_set_content_$ref_pketfb,
} from '../views/direct/TextView.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  ThemeForElement22lj47hlivf8f as ThemeForElement,
  _Step___init__impl__1kywol116oveu812gz as _Step___init__impl__1kywol,
} from '../views/NativeElement.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { LiveRegionMode_Assertive_getInstanceh7tqh38ym97g as LiveRegionMode_Assertive_getInstance } from '../models/LiveRegionMode.mjs';
import { generateSequence118suk3hffuuw as generateSequence } from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/Sequences.mjs';
import { findFirstInteractiveDescendant11suf5uyp4f72 as findFirstInteractiveDescendant } from '../views/l2/labels.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_ValidationTheming() {
  _init_properties_validation_kt__gvz4c9();
  return ValidationTheming;
}
var ValidationTheming;
function validate(_this__u8e3s4, validates, appliedWhen) {
  var tmp;
  if (appliedWhen === VOID) {
    tmp = validate$lambda;
  } else {
    tmp = appliedWhen;
  }
  appliedWhen = tmp;
  _init_properties_validation_kt__gvz4c9();
  return beforeSetup(_this__u8e3s4, ($this$beforeSetup) => {
    applyValidationTheming($this$beforeSetup, validates, appliedWhen);
    return Unit_instance;
  });
}
function issueText(_this__u8e3s4, issues, transform, shownWhen_0) {
  var tmp;
  if (transform === VOID) {
    tmp = issueText$lambda;
  } else {
    tmp = transform;
  }
  transform = tmp;
  var tmp_0;
  if (shownWhen_0 === VOID) {
    tmp_0 = issueText$lambda_0;
  } else {
    tmp_0 = shownWhen_0;
  }
  shownWhen_0 = tmp_0;
  _init_properties_validation_kt__gvz4c9();
  // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_0 = themed(shownWhen(_this__u8e3s4, VOID, VOID, ($this$shownWhen) => {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    if (shownWhen_0($this$shownWhen)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !$this$shownWhen.invoke_r7m7el_k$(issues).isEmpty_y1axqb_k$();
    } else {
      tmp = false;
    }
    return tmp;
  }), ErrorSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
  var tmp_1 = KMutableProperty0();
  var tmp_2 = TextView$_get_content_$ref_4pzcwl(element);
  var tmp_3 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb(element));
  element.invoke_bnq13k_k$(tmp_3, ($this$invoke) => joinToString($this$invoke.invoke_r7m7el_k$(issues), '\n', VOID, VOID, VOID, VOID, transform));
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  var issueView = element;
  issueView.set_accessibleLiveRegion_kq920e_k$(LiveRegionMode_Assertive_getInstance());
  var tmp_4 = issueView.get_parent_hy4reb_k$();
  var tmp0 = generateSequence(tmp_4, issueText$lambda_1);
  var tmp$ret$7;
  $l$block: {
    // Inline function 'kotlin.sequences.firstNotNullOfOrNull' call
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element_0 = _iterator__ex2g4s.next_20eer_k$();
      var result = findFirstInteractiveDescendant(element_0);
      if (!(result == null)) {
        tmp$ret$7 = result;
        break $l$block;
      }
    }
    tmp$ret$7 = null;
  }
  var tmp0_safe_receiver = tmp$ret$7;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    tmp0_safe_receiver.set_describedBy_4bf3cf_k$(issueView);
  }
}
function applyValidationTheming(_this__u8e3s4, validates, appliedWhen) {
  var tmp;
  if (appliedWhen === VOID) {
    tmp = applyValidationTheming$lambda;
  } else {
    tmp = appliedWhen;
  }
  appliedWhen = tmp;
  _init_properties_validation_kt__gvz4c9();
  var invalid = {_v: false};
  var e = _this__u8e3s4.get_underlyingNativeElement_vngz33_k$();
  var tmp_0 = e.themePipeline_1;
  var tmp_1 = get_ValidationTheming();
  var tmp_2 = (it) => invalid._v ? InvalidSemantic_getInstance() : None_instance;
  tmp_0.add_n6yx8s_k$(tmp_1, new (sam$com_lightningkite_kiteui_views_NativeElementCommonCode_ThemePipeline_ThemeForElement$0())(tmp_2));
  reactive(_this__u8e3s4, VOID, ($this$reactive) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp = appliedWhen($this$reactive);
    var tmp0 = validates;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var inductionVariable = 0;
      var last = tmp0.length;
      while (inductionVariable < last) {
        var element = tmp0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!$this$reactive.invoke_r7m7el_k$(get_issues(element)).isEmpty_y1axqb_k$()) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    var newState = !!(tmp & tmp$ret$1);
    var tmp_0;
    if (!(newState === invalid._v)) {
      invalid._v = newState;
      e.refreshTheming_1agefv_k$();
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  });
}
var sam$com_lightningkite_kiteui_views_NativeElementCommonCode_ThemePipeline_ThemeForElement$0Class;
function sam$com_lightningkite_kiteui_views_NativeElementCommonCode_ThemePipeline_ThemeForElement$0() {
  if (sam$com_lightningkite_kiteui_views_NativeElementCommonCode_ThemePipeline_ThemeForElement$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      get_31089n_k$(element) {
        return this.function_1(element);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, ThemeForElement()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$com_lightningkite_kiteui_views_NativeElementCommonCode_ThemePipeline_ThemeForElement$0', VOID, VOID, [ThemeForElement(), FunctionAdapter()]);
    sam$com_lightningkite_kiteui_views_NativeElementCommonCode_ThemePipeline_ThemeForElement$0Class = $;
  }
  return sam$com_lightningkite_kiteui_views_NativeElementCommonCode_ThemePipeline_ThemeForElement$0Class;
}
function validate$lambda(_this__u8e3s4) {
  _init_properties_validation_kt__gvz4c9();
  return true;
}
function issueText$lambda(it) {
  _init_properties_validation_kt__gvz4c9();
  return it.summary_1;
}
function issueText$lambda_0(_this__u8e3s4) {
  _init_properties_validation_kt__gvz4c9();
  return true;
}
function issueText$lambda_1(it) {
  _init_properties_validation_kt__gvz4c9();
  return it.get_parent_hy4reb_k$();
}
function applyValidationTheming$lambda(_this__u8e3s4) {
  _init_properties_validation_kt__gvz4c9();
  return true;
}
var properties_initialized_validation_kt_mazqbp;
function _init_properties_validation_kt__gvz4c9() {
  if (!properties_initialized_validation_kt_mazqbp) {
    properties_initialized_validation_kt_mazqbp = true;
    ValidationTheming = _Step___init__impl__1kywol(0.5);
  }
}
//region block: exports
export {
  issueText as issueText2kcb4l1c5xll7,
  validate as validate3385a3bw04nw6,
};
//endregion

//# sourceMappingURL=validation.mjs.map
